// const STAGE = process.env.NEXT_PUBLIC_STAGE || "ylerner";

export const BaseUrl = "https://wstest.hamazon.co.il/";
export const S3Url = "https://d2hlhkfvlx0wnu.cloudfront.net";
export const newS3Url = "https://images.pim.slssystems.net/";
export const newApiBaseUrl = "https://api.pgw.slssystems.net/v1";
export const newS3BucketUrl =
  "https://pim-imagesbucketv1-ccaxsrva.s3.eu-west-1.amazonaws.com";

export const awsUrl = "https://api.hamazononline.com";

export const tranzilaMasof = "hamazont";

export const aspNetUrl = BaseUrl + "api/";
// export const url ="http://localhost:81/api/"
export const globalFileServer = S3Url + "/images/";
export const newGlobalFileServer = newS3Url;
// export const globalFileServer ="https://img.hamazon.co.il/img/image/";
// export const globalFileServer ="https://cdn-img.hamazon.co.il/img/";
// export const globalFileServer2 =BaseUrl+"img/";
//"http://51.195.119.118/img/image/icons/about.svg"
export const globalFileIcon = globalFileServer + "iconcss/";
//BaseUrl +"img/iconcss/";
//""+"iconcss/";
export const sortCategoryId = 1127;
